import { render, staticRenderFns } from "./ApprovedWfh.vue?vue&type=template&id=2013cb68"
import script from "./ApprovedWfh.vue?vue&type=script&lang=js"
export * from "./ApprovedWfh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports